const metaTag = document.querySelector("meta[name='csrf-token']");

const defaultOptions = {
  method: "post",
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-Token': metaTag && metaTag.content
  },
  credentials: 'same-origin'
};

const fetchPost = async (url, options) => {
  const response = await fetch(url, Object.assign({}, defaultOptions, options));
  const json = await response.json();
  if (json.errors) {
    throw new Error(json.errors);
  }
  return json;
};

export default fetchPost;
